<template>
  <div class="divBox">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="container">
          <el-form size="small" inline label-width="100px">
            <el-form-item label="关键字：" class="width100" style="display: inline-block;">
              <el-input
                v-model="tableFrom.keyword"
                @keyup.enter.native="getList(1)"
                placeholder="sku/分类名称"
                class="selWidth"
                size="small"
              >
                <el-button slot="append" icon="el-icon-search" size="small" class="el-button-solt" @click="getList(1)"/>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <el-table
        v-loading="listLoading"
        :data="tableData.data"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          label="ID"
          prop="recovery_category_id"
          min-width="60"/>
        <el-table-column
          label="品类"
          prop="sku"
          min-width="260">
          <template slot-scope="scope">
              <span>
                <span v-if="scope.row.cate_name">
                  {{scope.row.cate_name}}/
                </span>
                {{scope.row.sku}}
              </span>
          </template>
        </el-table-column>
        <el-table-column
          label="批号"
          min-width="200"
          prop="batch_number">
        </el-table-column>
        <el-table-column
          label="添加数量"
          min-width="200"
          prop="wareHous_num">
        </el-table-column>
        <el-table-column
          label="价格"
          prop="wareHous_price"
          min-width="100">
          <template slot-scope="scope">
            {{scope.row.wareHous_price || '0.00'}}
          </template>
        </el-table-column>
        <el-table-column
          label="总价"
          min-width="200"
          prop="wareHous_amount">
          <template slot-scope="scope">
            {{scope.row.wareHous_amount || '0.00'}}
          </template>
        </el-table-column>
        <el-table-column
          label="备注"
          min-width="200"
          prop="wareHous_remark">
        </el-table-column>
        <el-table-column
          label="时间"
          min-width="200"
          prop="create_time">
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          :page-sizes="[20, 40, 60, 80]"
          :page-size="tableFrom.limit"
          :current-page="tableFrom.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
          @size-change="handleSizeChange"
          @current-change="pageChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import {roterPre} from '@/settings'
import {fromList} from "@/libs/constants";
import {
  addWarehousList,
} from "@/api/recovery";
export default {
  name: 'WarehousAddList',
  components: {},
  computed:{
  },
  data() {
    return {
      props: {checkStrictly: true, emitPath: false},
      moren: require("@/assets/images/f.png"),
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      },
      roterPre: roterPre,
      tableFrom: {
        page: 1,
        limit: 20,
      },
      orderChartType: {},
      fromList: fromList,
      loading: false,

    }
  },
  mounted() {
    this.getList(1)
  },
  methods: {
    // 列表
    getList(num) {
      this.listLoading = true
      this.tableFrom.page = num ? num : this.tableFrom.page
      console.log(this.tableFrom)
      addWarehousList(this.tableFrom).then(res => {
        this.tableData.data = res.data.list
        this.tableData.total = res.data.count
        console.log(this.tableData.data)
        this.checkedIds = []
        this.listLoading = false
      }).catch(res => {
        this.listLoading = false
        this.$message.error(res.message)
      })
    },
    pageChange(page) {
      this.tableFrom.page = page
      this.getList('')
    },
    handleSizeChange(val) {
      this.tableFrom.limit = val
      this.getList('')
    },
  }
}
</script>

<style scoped lang="scss">
/deep/.boxDetial .el-form-item {
  margin-bottom: 0px;
}
/deep/.el-form-item{
  /*margin-bottom: 0!important;*/
}
.box-container {
  overflow: hidden;
}

.box-container .list {
  float: left;
  line-height: 40px;
}

.box-container .sp {
  width: 50%;
}

.box-container .sp3 {
  width: 33.3333%;
}

.box-container .sp100 {
  width: 100%;
}
.decla_row{
  width: 100%;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  margin:40px 0 0;
  padding: 20px 20px 0;
  box-sizing: border-box;
}
.batch_num{
  color: red;
  font-size: 16px;
}
.decla_title{
  font-size: 16px;
  font-weight: bold;
}
.box-container .list .name {
  display: inline-block;
  width: 150px;
  text-align: right;
  color: #606266;
}
.skuList{
  border-bottom: 2px solid #f4f4f5;
  margin-bottom: 10px;
}
.blodClass{
  font-size:14px;
  color: red;
  font-weight: bold;
}
.box-container .list.image {
  margin-bottom: 40px;
}

.box-container .list.image img {
  position: relative;
  top: 40px;
}

.btnss{
  position: absolute;
  bottom: 0;
  right: 40px;

}
/deep/ .el-form-item__content .el-rate {
  position: relative;
  top: 8px;
}
.cate_name{
  width: 200px;
}
.sku-tb {
  border: 1px solid black;
  border-collapse: collapse;
  margin-bottom: 20px;
  width: 750px;
  tr {
    th, td {
      border: 1px solid black;
      text-align: center;

      .sku-name {
        margin: 0 auto;
        width: 100px;
        /*height: 30px;*/
        /*overflow: hidden;*/
        line-height: 24px;
        text-overflow: ellipsis;
        /*word-break: keep-all;*/
      }
    }
  }
}
</style>
